import { render, staticRenderFns } from "./AssessmentDrives.vue?vue&type=template&id=6b0ece11&"
import script from "./AssessmentDrives.vue?vue&type=script&lang=js&"
export * from "./AssessmentDrives.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports